export const CarouselItemActionType = {
  PrimaryButtonClick: 'primaryButtonClick',
  SecondaryButtonClick: 'secondaryButtonClick',
};

export default {
  CarouselItemActionType,
};
